import { BadgeCheck } from "lucide-react";

/**
 * Small ✓ badge for users who have the Verified role in the Serverlistr Discord.
 * Renders nothing when `verified` is falsy so we can inline this anywhere safely.
 */
export default function VerifiedBadge({ verified, size = 14, className = "", label = true }) {
  if (!verified) return null;
  return (
    <span
      title="Verified in Serverlistr Discord"
      data-testid="verified-badge"
      className={`inline-flex items-center gap-1 text-neon-cyan ${className}`}
    >
      <BadgeCheck style={{ width: size, height: size }} className="fill-neon-cyan/15" />
      {label && <span className="text-[10px] font-mono uppercase tracking-wider">Verified</span>}
    </span>
  );
}
